module.exports = __webpack_public_path__ + "static/img/shulishangye.dc3746b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/custom/shulishangye.png
// module id = 7WTj
// module chunks = 1